import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { apiErr } from "../lib/api";

const Login = () => {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back.");
      nav(u.role === "admin" ? "/admin" : "/portal");
    } catch (err) {
      toast.error(apiErr(err, "Invalid email or password"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#12201A] flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-full border border-[#C9B79C]/40 flex items-center justify-center mb-4"><Lock size={20} className="text-[#C9B79C]" /></div>
          <h1 className="font-display text-3xl text-[#F3EEE3]">Builders Login</h1>
          <p className="text-[#F3EEE3]/55 text-sm mt-2">Access confidential documents and the investor portal.</p>
        </div>
        <form onSubmit={submit} className="rounded-2xl border border-[#F3EEE3]/12 bg-[#0F1B15] p-8 space-y-4">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="login-email" className="w-full bg-[#0C1510] border border-[#F3EEE3]/15 rounded-lg px-4 py-3 text-[#F3EEE3] placeholder:text-[#F3EEE3]/35 focus:border-[#C9B79C] outline-none" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="login-password" className="w-full bg-[#0C1510] border border-[#F3EEE3]/15 rounded-lg px-4 py-3 text-[#F3EEE3] placeholder:text-[#F3EEE3]/35 focus:border-[#C9B79C] outline-none" />
          <button type="submit" disabled={busy} data-testid="login-submit" className="w-full bg-[#F3EEE3] text-[#12201A] px-6 py-3.5 rounded-full font-medium hover:bg-white transition-colors disabled:opacity-60">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
